import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../../shared/models/jobTypeCourt.model';

import { CreateJobTypeComponent} from './../create-job-type.component';
import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map, Subscription} from 'rxjs';

import { JobTypeDocument } from '../../../../shared/models/jobTypeDocument.model';
import { JobTypeAffidavit } from '../../../../shared/models/jobTypeAffidavit.model';

import { JobServiceRule } from '../../../../shared/models/jobServiceRule.model';

@Component({
  selector: 'app-update-service-rule',
  templateUrl: './update-service-rule.component.html',
  styleUrls: ['./update-service-rule.component.css']
})
export class UpdateServiceRuleComponent implements OnInit {


  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_court: any;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_service_rule: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef
  ) { }


  ngOnChanges() {
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
  this.model = new JobServiceRule();
 this.model = this.getJobServiceRule(this.count);
  this.getJobTypes();


  }

  ngOnInit() {
  }





  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    // this.model.job_type_location_id = 1;
   // this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }


  getJobTypeCourt(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
       data => { this.job_type_court = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeDocument(job_type_document_type_id) {
    this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
       data => { this.job_type_document = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   getJobTypeAffidavit(job_type_affidavit_type_id) {
    this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
       data => { this.job_type_affidavit = data; 
        let res = data[0];
       // this.model.job_type_id = res.job_type_id;
        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
      
      
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   



   getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   updateJobServiceRule(model) {
    this._demoService.updateJobServiceRule(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Service Rule Updated');
       // Subject to reload the manager component parent.
       this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Service Rule!');
         return console.error(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }


   updateJobTypeAffidavit(model) {
    this._demoService.updateJobTypeAffidavit(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Affidavit Type Updated');
       // Subject to reload the manager component parent.
       this.closeParentModel.emit();
       // CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Affidavit!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }
    


    
    getJobTypeCourts(job_type_location_id) {
      this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
         data => { this.job_type_courts = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeCourtsID(job_type_location_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_location_id = job_type_location_id;
      this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
    
    }


    getJobTypeDocumentTypes(job_type_court_id) {
      this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
         data => { this.job_type_document_types = data; },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
     sendJobTypeDocumentTypesID(job_type_court_id) {
      // this.initialCount = this.trace_candidates.trace_candidate_id;
      this.sent_job_type_court_id = job_type_court_id;
      this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
    }



}
